import { FamilyService } from '@app/services/family/family.service';
import { Component } from '@angular/core';
import { PdvService } from '@app/services/pdv/pdv.service';
@Component({
    selector: 'menus',
    templateUrl: 'menus.component.html',
    styleUrls: ['menus.component.scss'],
    providers: [FamilyService]
})
export class MenusComponent {
    menucategories: any[] = [];
    loading = false;
    city = "";
    constructor(private familyService: FamilyService, private pdvService: PdvService) {
        this.pdvService.pdv.subscribe(
            (pdv) => {
                if (pdv) {
                    this.city = pdv.city;
                }
            }
        )
    }
    ngOnInit() {
        this.getMenuCategoriesOfCarte();
    }
    getMenuCategoriesOfCarte() {
        this.loading = true;
        this.familyService.getMenuCategoriesOfCarte().subscribe(
            (menucategories: any[]) => {
                this.menucategories = menucategories.sort(
                    (a,b)=>{
                        if (a.order === null) {
                            return 1;
                        }
                        else if (b.order === null) {
                            return -1;
                        }
                        if(a.order>b.order){
                            return 1;
                        }
                        if(a.order<b.order){
                            return -1;
                        }
                        return 0;
                    }
                )
                this.loading = false;
            }
        )
    }
}
